const CommonParams = [
  'original_filename',
  'mime_type',
  'author_institution',
  'unix',
  'deeplink',
  'access_key',
  'category',
  'source',
  'link',
  'category_tab',
];

const DocumentViewerParams = [
  ...CommonParams,
  'fileType',
  'searchTerm',
  'boundingBox',
  'pageNumber',
];
const ImageViewerParams = [...CommonParams, 'dimensions'];

export const getUrlForViewer = (
  fileType: string,
  state: Record<string, unknown>
): string => {
  const searchParams = new URLSearchParams();

  const requiredParams =
    fileType === 'document' ? DocumentViewerParams : ImageViewerParams;

  Object.keys(state).forEach((param) => {
    if (requiredParams.includes(param) && state[param] !== undefined) {
      searchParams.set(param, JSON.stringify(state[param]));
    }
  });

  return `/${fileType}?${searchParams}`;
};
